import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Divider, Spacing } from '@zep/ui';
import { OperationType } from '../../../../../../types';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../../../PlanPaymentSection/Providers';
import { PlanPaymentDatePicker } from '../PlanPaymentDatePicker';
import { PlanNotiText } from '../shared';
import { CustomOnetimeMonthSelect } from './CustomOnetimeMonthSelect';
export const SetCustomOnetimeStartDate = () => {
  const {
    control,
    watch
  } = usePlanPaymentFormContext();
  const isCustomOnetimePeriod = watch('isCustomOnetimePeriod');
  const {
    currentOperationType
  } = usePlanPaymentInfoContext();
  const {
    t
  } = useTranslation(['subscription']);
  return <>
      <Spacing size={32} data-sentry-element="Spacing" data-sentry-source-file="SetCustomOnetimeStartDate.tsx" />
      <Divider data-sentry-element="Divider" data-sentry-source-file="SetCustomOnetimeStartDate.tsx" />
      <Spacing size={32} data-sentry-element="Spacing" data-sentry-source-file="SetCustomOnetimeStartDate.tsx" />
      <h2 className="text-[17px] font-[700] text-gray-900">
        {t('subscription:payment.duration.NmonthsStartDate', {
        defaultValue: '시작일 설정'
      })}
      </h2>
      <Spacing size={14} data-sentry-element="Spacing" data-sentry-source-file="SetCustomOnetimeStartDate.tsx" />
      <div className="flex w-full items-center gap-[10px] rounded-[10px] border border-gray-200 px-[20px] py-[18px]">
        {isCustomOnetimePeriod && <div className="max-w-[120px]">
            <CustomOnetimeMonthSelect />
          </div>}
        <Controller control={control} name="onetimeStartDate" render={({
        field
      }) => {
        return <PlanPaymentDatePicker selected={field.value} onSelect={field.onChange} disabled={currentOperationType === OperationType.일시납} />;
      }} data-sentry-element="Controller" data-sentry-source-file="SetCustomOnetimeStartDate.tsx" />
      </div>
      <Spacing size={10} data-sentry-element="Spacing" data-sentry-source-file="SetCustomOnetimeStartDate.tsx" />
      <PlanNotiText alertText={t('subscription:payment.calendar.cantChangeStartDay', {
      defaultValue: '한 번 결제된 플랜은 시작일을 변경할 수 없습니다'
    })} data-sentry-element="PlanNotiText" data-sentry-source-file="SetCustomOnetimeStartDate.tsx" />
    </>;
};